import React from 'react';
import { Link, useLocation } from 'react-router-dom';

/**
 * Inline disclaimer for AI-generated content
 * Displayed on lecture pages to inform users about content generation
 * @param {Object} props - Component props
 * @param {boolean} [props.compact=false] - Use compact styling
 * @returns {JSX.Element} AIContentDisclaimer component
 */
const AIContentDisclaimer = ({ compact = false }) => {
  const location = useLocation();

  const styles = {
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '6px',
      padding: compact ? '6px 12px' : '8px 16px',
      borderTop: '1px solid rgba(0, 0, 0, 0.06)',
    },
    text: {
      fontSize: compact ? '11px' : '11.5px',
      lineHeight: '1.4',
      color: '#999',
      margin: 0,
      textAlign: 'center',
    },
    link: {
      color: '#888',
      textDecoration: 'underline',
      fontWeight: 400,
    },
  };

  return (
    <div style={styles.container} role="contentinfo" aria-label="Content Note">
      <p style={styles.text}>
        Content enhanced with AI assistance for your learning experience.
        Spot something off?{' '}
        <Link
          to={`/feedback${location.search}`}
          style={styles.link}
        >
          Let us know
        </Link>.
      </p>
    </div>
  );
};

export default AIContentDisclaimer;
